/// <reference path="../../../../state/rdms/types.js" />
//@ts-check
import { AvatarHolder, AvatarsContainer, PlaceHolderCounter } from "./styles";

/**
 * @typedef {Object} RelatedUsersProps
 * @property {RdmUser[]} users
 */

/**
 * @param {RelatedUsersProps} props
 * @returns {JSX.Element}
 */
export function RelatedUsers({ users }) {
  return (
    <AvatarsContainer>
      {users.length > 0 && users.length < 5
        ? users.map((item, index) => (
            <AvatarHolder
              key={Math.random() + index}
              src={item.userData.avatarURL}
            />
          ))
        : users.length >= 5
        ? users
            .slice(0, 5)
            .map((item, index) => (
              <AvatarHolder
                key={Math.random() + index}
                src={item.userData.avatarURL}
              />
            ))
        : "-"}
      {users.length >= 5 ? (
        <div style={{ display: users.length - 5 ? "flex" : "none" }}>
          <PlaceHolderCounter>{"+" + (users.length - 5)}</PlaceHolderCounter>
        </div>
      ) : null}
    </AvatarsContainer>
  );
}
